import { GridActionsCellItem } from '@mui/x-data-grid';
import { useState } from 'react';
import DurationPickerDialog from './DurationPickerDialog';

function EditWorkHoursActionItem({ handleSubmit, id, value, ...props }) {
    const [open, setOpen] = useState(false);

    const onDialogClose = () => {
        setOpen(false);
    };

    return (
        <>
            <GridActionsCellItem {...props} onClick={() => setOpen(true)} />
            <DurationPickerDialog handleSubmit={handleSubmit} id={id} value={value} open={open} onClose={onDialogClose} type={'positive'}/>
        </>
    );
};

export default EditWorkHoursActionItem
